import { createSelector } from '@reduxjs/toolkit';
import { selectCmsFromBootstrap, selectGeoFromBootstrap } from 'store/slice/bootstrap';
import { CmsValue, Geo } from 'core/type/BootstrapConfig.types';
import { getSearchPageFromCityIdAndKeyword } from 'core/utils/activityUrlGenerator';
import { routeTo } from 'store/slice/navigation';
import { selectScreenSize } from 'store/slice/screen';

interface StateProps {
    cms: CmsValue;
    isDesktop: boolean;
    geo?: Geo;
}

interface DispatchProps {
    onKeywordResultClick: (keyword: string, geo: Geo) => void;
}

interface OwnProps {
    inputText: string;
}

export type InCitySearchOverlayProps = OwnProps & StateProps & DispatchProps;

export const mapStateToProps = createSelector(selectCmsFromBootstrap, selectGeoFromBootstrap, selectScreenSize, (cms, geo, screenSize): StateProps => {
    return {
        cms,
        geo,
        isDesktop: screenSize.desktop,
    };
});

export const mapDispatchToProps = (dispatch: Function): DispatchProps => ({
    onKeywordResultClick: (keyword: string, geo: Geo) => {
        const searchPageUrl = getSearchPageFromCityIdAndKeyword(geo.cityId, keyword);
        dispatch(routeTo(searchPageUrl));
    },
});
